import * as React from "react";
import { LocaleNames, PreferredLocale } from "../../../../../utils/locales";
import {
  LanguageSectionTitle,
  LanguageSelectionSection,
  SelectLanguageContainer,
  Select,
} from "./LocaleFilterSelection.styles";
import { LanguageIcon } from "../../AnalyticsIcons";
import { UnitChartType } from "../../../../../App/Analytics/Common";

export interface ILocaleFilterSelectionBaseProps {
  onSelectLocale: (locale: React.ChangeEvent<HTMLSelectElement>) => void;
  supportedLocales: PreferredLocale[];
  selectedLocale: PreferredLocale | undefined;
}

interface ILocaleFilterSelectionProps extends ILocaleFilterSelectionBaseProps {
  localeFilterType: UnitChartType;
}

const LocaleFilterMessage: React.FC<{ type: UnitChartType }> = ({ type }) => {
  if (type === UnitChartType.Questions) {
    return (
      <>
        Select a language if you want to filter the results of <strong>Lesson questions</strong> or{" "}
        <strong>Assessment questions</strong>:
      </>
    );
  }

  if (type === UnitChartType.Instruction) {
    return <>Select the language to view the question in. The results for that language will be shown below.</>;
  }

  return <></>;
};

const LocaleFilterSelection: React.SFC<ILocaleFilterSelectionProps> = ({
  onSelectLocale,
  supportedLocales,
  selectedLocale,
  localeFilterType,
}) => {
  /* If there is only one language supported, this section is omitted */
  if (supportedLocales.length < 2) {
    return null;
  }
  return (
    <>
      <LanguageSectionTitle data-testid="language-selection-title">
        <LanguageIcon /> Language Selection
      </LanguageSectionTitle>
      <LanguageSelectionSection data-testid="language-selection-section">
        <SelectLanguageContainer>
          <label htmlFor="language-filter">
            <i>
              <LocaleFilterMessage type={localeFilterType} />
            </i>
          </label>
          <Select name="language-filter" onChange={onSelectLocale} value={selectedLocale}>
            <option>All languages</option>
            {...supportedLocales.map(l => (
              <option key={l} value={l}>
                {LocaleNames[l]}
              </option>
            ))}
          </Select>
        </SelectLanguageContainer>
      </LanguageSelectionSection>
    </>
  );
};

export default LocaleFilterSelection;
